import Button from '@/components/Button';
import StoreAdditiveComboBox, {
  StoreAdditiveComboBoxItem,
} from '@/components/StoreAdditiveComboBox';

interface ProductListStoreAssignmentFormProps {
  productListId: string;
  supplierId?: string;
  selectedIds: (string | number)[];
  stagedCount: number;
  onSelect: (item: StoreAdditiveComboBoxItem) => void;
  onAssign: () => Promise<void> | void;
  submitting?: boolean;
}

const ProductListStoreAssignmentForm = ({
  productListId,
  supplierId,
  selectedIds,
  stagedCount,
  onSelect,
  onAssign,
  submitting = false,
}: ProductListStoreAssignmentFormProps) => (
  <div className="mb-4 flex flex-col gap-3 sm:flex-row sm:items-end">
    <div className="w-full sm:max-w-md">
      <StoreAdditiveComboBox
        productListId={productListId}
        supplierId={supplierId}
        selectedIds={selectedIds}
        onAdd={onSelect}
        disabled={submitting}
      />
    </div>

    <div className="flex items-center gap-3">
      <Button
        onClick={() => void onAssign()}
        loading={submitting}
        disabled={stagedCount === 0}
        variant="primary"
      >
        Assign selected stores
      </Button>
      {stagedCount > 0 && (
        <span className="text-sm text-gray-600">
          {stagedCount} {stagedCount === 1 ? 'store' : 'stores'} selected
        </span>
      )}
    </div>
  </div>
);

export default ProductListStoreAssignmentForm;
